// ============================================================================
// Locations — `.js-open-select` chevron opens the wrapping <label>'s <select>
// Uses showPicker() when available (only reliable cross-browser way); else focus().
// ============================================================================
(function ($) {
    'use strict';

    $(function () {
        $(document).on('click', '.js-open-select', function (e) {
            const sel = $(this).closest('label').find('select')[0];
            if (!sel) return;

            if (typeof sel.showPicker === 'function') {
                e.preventDefault();
                try {
                    sel.showPicker();
                    return;
                } catch (_) {
                    // showPicker throws if not user-initiated — fall through to focus
                }
            }
            sel.focus();
        });
    });
})(jQuery);
